<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n();
</script>

<template>
  
  <!-- Section Title -->
  <h6>{{ t('summaries_onboarding_get_updates') }}</h6>

  <!-- Summary Types -->
  <div class="row sum-types">

    <!-- Milestones -->
    <div class="col-auto sum-types__milestones">

      <!-- Graphic -->
      <img :alt="t('gait_milestones')"
           src="/img/rcvy-updts-onbd-milestones.svg" />

      <!-- Heading -->
      <h6 class="mb-none">{{ t('gait_milestones') }}</h6>

      <!-- Description -->
      <p>{{ t('summaries_onboarding_celebrate') }}</p>
    </div>

    <!-- Stand Out Days -->
    <div class="col-auto sum-types__stand-out">

      <!-- Graphic -->
      <img :alt="t('summaries_onboarding_stand_out_days')"
           src="/img/rcvy-updts-onbd-stand-out.svg" />

      <!-- Heading -->
      <h6 class="mb-none">{{ t('summaries_onboarding_stand_out_days') }}</h6>

      <!-- Description -->
      <p>{{ t('summaries_onboarding_better_or_worse') }}</p>
    </div>

    <!-- Trends -->
    <div class="col-auto sum-types__trends">

      <!-- Graphic -->
      <img :alt="t('summaries_onboarding_trends')"
           src="/img/rcvy-updts-onbd-trends.svg" />

      <!-- Heading -->
      <h6 class="mb-none">{{ t('summaries_onboarding_trends') }}</h6>

      <!-- Description -->
      <p>{{ t('summaries_onboarding_track_progress') }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';

h6 {
  font-weight: map.get($text-weights, semibold);
  line-height: 20px;
  margin-block-end: 16px;
}

// Summary Types
.sum-types { // .row
  gap: 8px;
  margin-block-end: 24px;

  > .col-auto {
    $width: 160px;

    width: 160px;
    max-width: 160px;
    min-height: 206px;
    background-color: $white;
    padding: 16px;
    overflow: hidden;
    flex-basis: 160px;
    border-radius: $generic-border-radius;
    box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.05), 0 0 2px -1px rgba(0, 0, 0, 0.03), 0 0 4px -1px rgba(0, 0, 0, 0.06), 0 2px 6px -2px rgba(0, 0, 0, 0.04);
  }

  img {
    $size: 128px;

    width: $size;
    height: $size;
    border-radius: $generic-border-radius-sm;
    margin-block-end: 8px;
  }

  p {
    font-size: 12px;
    line-height: 17px;
    color: map.get($co-brand-clrs, content-txt-ttl);
  }
}


</style>